import type { useI18n } from '@hive/i18n';
import { track } from '@hive/track';
import { ContactWithUsIcon, NewIcon } from '@blocksuite/icons/rc';

import type { WorkspaceDialogService } from '../modules/dialogs';
import type { UrlService } from '../modules/url';
import { registerHiveCommand } from './registry';

export function registerHiveHelpCommands({
  t,
  urlService,
  workspaceDialogService,
}: {
  t: ReturnType<typeof useI18n>;
  urlService: UrlService;
  workspaceDialogService: WorkspaceDialogService;
}) {
  const unsubs: Array<() => void> = [];
  unsubs.push(
    registerHiveCommand({
      id: 'hive:help-whats-new',
      category: 'hive:help',
      icon: <NewIcon />,
      label: t['com.hive.cmdk.hive.whats-new'](),
      run() {
        track.$.cmdk.help.openChangelog();
        urlService.openPopupWindow(BUILD_CONFIG.changelogUrl);
      },
    })
  );
  unsubs.push(
    registerHiveCommand({
      id: 'hive:help-contact-us',
      category: 'hive:help',
      icon: <ContactWithUsIcon />,
      label: t['com.hive.cmdk.hive.contact-us'](),
      run() {
        track.$.cmdk.help.contactUs();
        workspaceDialogService.open('setting', {
          activeTab: 'about',
        });
      },
    })
  );

  return () => {
    unsubs.forEach(unsub => unsub());
  };
}
